import { useAppLock } from '@/feature/app-lock/composables/useAppLock';

const state = () => ({
  isLocked: false,
  biometryEnabled: false,
  pinEnabled: false,
  deviceIsSecure: true
});

const getters = {
  isLocked: state => state.isLocked,
  biometryEnabled: state => state.biometryEnabled,
  pinEnabled: state => state.pinEnabled,
  isAppLockEnabled: state => state.biometryEnabled || state.pinEnabled,
  deviceIsSecure: state => state.deviceIsSecure
};

const mutations = {
  setLocked(state, value) {
    state.isLocked = value;
  },
  setBiometryEnabled(state, value) {
    state.biometryEnabled = value;
  },
  setPinEnabled(state, value) {
    state.pinEnabled = value;
  },
  setDeviceIsSecure(state, value) {
    state.deviceIsSecure = value;
  }
};

const actions = {
  async reset({ commit }) {
    await useAppLock().reset();
    commit('setLocked', false);
    commit('setBiometryEnabled', false);
    commit('setPinEnabled', false);
  }
};

export const appLock = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
